import { useMemo } from 'react';
import { useTheme } from '../context/ThemeProvider';
import { CHART_VARS } from '../constants/statusConfig';

// Reads live CSS-variable colors so recharts (which needs concrete color
// strings, not classes) stays in sync with light/dark. Recomputes whenever
// the theme flips.
export const useChartTheme = () => {
  const { theme } = useTheme();

  return useMemo(() => {
    const read = (name, fallback) => {
      if (typeof window === 'undefined') return fallback;
      const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
      return raw ? `rgb(${raw})` : fallback;
    };

    return {
      palette: CHART_VARS.map((v) => read(v, '#6366f1')),
      grid: read('--chart-grid', '#e2e8f0'),
      axis: read('--chart-axis', '#64748b'),
      surface: read('--surface', '#ffffff'),
      border: read('--border', '#e2e8f0'),
      foreground: read('--foreground', '#0f172a'),
      status: {
        pending: read('--status-pending', '#ca8a04'),
        confirmed: read('--status-confirmed', '#2563eb'),
        completed: read('--status-completed', '#16a34a'),
        canceled: read('--status-canceled', '#dc2626'),
      },
    };
    // `theme` is the intentional trigger for re-reading the CSS vars.
  }, [theme]);
};
